import {
    clinicSqbOrderPay,
    confirmMedicalOrderCashPayment,
    confirmMedicalOrderSelfScanPayment,
    bindMiniPatientIdentity,
    clinicSqbQueryResult,
    getDicts,
    getMedicalOrderDetail,
    getMedicalOrderPaymentReceipt,
    getMiniOrderIdentityReservations
} from "@/api";
import baseConfig from "@/api/config";
import {message} from "@/assets/utils/common";
import {ElMessageBox} from "element-plus";
import officialAccountQrCode from "@/assets/images/official-account-qrcode.jpg";
import {getDecoctionName, refreshDecoctionNameMap} from "@/assets/utils/decoction";

/**
 * pending 自动轮询窗口（秒）。取 150s 的两条约束：
 * ① 不得大于后端扫码支付锁的 TTL（ISqbOrderPayServiceImpl.SCAN_PAY_LOCK_MINUTES = 10 分钟）——
 *    窗口先到点而锁还在，会出现「页面已转待人工核查、收银员想重扫却被锁挡住」的自相矛盾状态；
 * ② 必须盖住后端补查阶梯 —— pending 落地时距发起已约 60s（SCAN_REQUEST_BUDGET_MS），
 *    两跳补查（间隔 +30s / +60s）落在 pending 落地后 +30s / +90s（即发起后约 +90s / +150s）；
 *    窗口从 pending 回包起算，留 60s 余量；到点后后端已有最终结论（收敛落库或自动撤单），收银员可放心关闭。
 */
const PAY_PENDING_WINDOW_SECONDS = 150;
/** pending 期间两次查单之间的间隔（秒） */
const PAY_PENDING_POLL_INTERVAL_SECONDS = 10;

export default {
    props: {
        orderId: "",
        paymentOnly: {type: Boolean, default: false},
        printOnly: {type: Boolean, default: false}
    },
    data() {
        return {
            userInfo: null,
            headImg: "",
            sysName: "",
            medicalOrder: {
                dppId: null, // 关联的病例ID
                docId: null, // 关联的医生ID
                docPatientCaseId: null, // 关联的病历ID
                conId: null,
                serialNo: null,
                docPrice: "0.00", //诊费
                clinicalDiagnosis: null, // 诊断结果
                medicineType: "0", //药剂类型
                billingType: '0', // 开单类型(0=颗粒,1=饮片,2=膏方,3=水丸)
                orderMedicineList: [], // 关联药品
                remark: null, //备注
                patientPhone: null,
                patientName: null, // 患者姓名
                patientSex: null, // 患者性别
                patientAge: null,  // 患者年龄
                patientIdentity: null, // 患者身份证
                oldOrderId: null,
                linkDoctorInfo: null,
                hasLinkDoctor: false,
                takeWay: "0",
                viceNum: "7", //药品副数
                // docAdvice: '每日一副 分两次服用（开水冲化 温服）',  //医嘱
                docAdvice: '开水温服',
                orderWeight: "0", // 药材总重
                medicalCountPrice: "0.00", //药材费用
                processingCosts: "0.00", //加工费用
                orderPrice: "0.00", //总价
                instructions: null,
                smsPhone: "",
                adjustmentPrice: "0.00",// 调理价格
                discountPrice: "0.00", // 优惠金额
                freeCasePic: "", // 科研药方的图片
                isFree: "1",
                dayTakeNum: "1", //X日一剂
                takeTimes: "2", // 每日分X次服用/每日X次
                timeUseNum: "1", // 每次XX克、XX毫升
                packWay: "0", // 包装方式 （0袋装 1瓶装）
                useWay: null, // 医嘱用法
                useAttention: null, // 医嘱禁忌
                fuCountPrice: 0,  // 辅药药品费用
                decoctType: '0', // 煎煮方式  0=自煎,1=代煎
                specification: '200', // 煎煮规格 规格 200ml/100ml
                orderMedicineFuList: [],  //辅药列表（和药品列表一样传参）
                completeTime: "",
                cancelTime: "",
                payTime: "",
            },
            doctorInfo: {
                docPrice: null,
                docPriceRate: null,
                docPriceWay: 0,
                docFreeOpen: "",
                docPriceHide: "0",
            },
            dictOrderStatus: 'sys_order_status',
            dictOrderStatusList: [],

            prescriptionPaperDialogDialogVisible: false, // 处方笺预览弹窗
            printDate: null, // 打印日期
            payCodeList: [], // 预览的支付码
            tencentCosUrl: baseConfig.tencentCosUrl,
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            showOrderMedicineFuList: "",
            paymentOnlyOpened: false,
            detailLoading: false,
            detailRequestId: 0, // 同单并发刷新也只能由最新一次回包更新详情

            printInfoObj: {
                id: 'printArea',
                popTitle: '知夏中医门诊部处方笺', // 打印配置页上方标题
                extraHead: '', //最上方的头部文字，附加在head标签上的额外标签,使用逗号分隔
                preview: '', // 是否启动预览模式，默认是false（开启预览模式，可以先预览后打印）
                previewTitle: '知夏中医门诊部处方笺', // 打印预览的标题（开启预览模式后出现）,
                previewPrintBtnLabel: '', // 打印预览的标题的下方按钮文本，点击可进入打印（开启预览模式后出现）
                zIndex: '', // 预览的窗口的z-index，默认是 20002（此值要高一些，这涉及到预览模式是否显示在最上面）
                previewBeforeOpenCallback() {}, //预览窗口打开之前的callback（开启预览模式调用）
                previewOpenCallback() {}, // 预览窗口打开之后的callback（开启预览模式调用）
                beforeOpenCallback() {}, // 开启打印前的回调事件
                openCallback() {}, // 调用打印之后的回调事件
                closeCallback() {}, //关闭打印的回调事件（无法确定点击的是确认还是取消）
                url: '',
                standard: '',
                extraCss: '',
            },
            orderPayDialogVisible: false, // 订单收费弹窗
            isMiniProgramOrder: false,
            needsIdentityBinding: false,
            miniIdentityReview: null,
            miniIdentityOptions: [],
            selectedMiniIdentity: '',
            manualMiniIdentity: '',
            miniIdentityQueryCompleted: false,
            miniIdentityLoading: false,
            miniIdentitySaving: false,
            miniIdentitySaved: false,
            miniIdentityError: '',
            miniIdentityRequestId: 0,
            payLoading: false, // 订单收费加载圈
            isWaitPayLoading: false, // 确认缴费后才等待扫码
            paymentMethod: 'SQB',
            manualPaymentUncertain: false,
            isPayed: false, // 是否完成订单收费
            successPayed: true, // 是否支付成功
            payState: "", // 收款三态：''（未发起）/ success / pending（结果确认中）/ failed
            payChannel: "", // 收款渠道：SQB（收钱吧）/ CASH（现金）/ FREE（免费单）
            payRequesting: false, // 支付请求在途（防止重复扫码发起第二个请求）
            paySessionEpoch: 0, // 弹窗/订单/扫码轮次，旧异步结果不得写入新会话
            payNeedsReview: false, // 外部已收款、本地待核查：只读查单，禁止重扫
            payReasonCode: '',
            payReviewOrderId: null, // 同单关窗重开仍保留外部已收款的禁重扫标记
            payPendingOrders: {}, // 按订单保留未知/已收款待核查态，切单或关窗不得恢复扣款
            payPendingReopened: false,
            querying: false, // 「重新查询」在途（手动与自动轮询共用，只作并发去重）
            manualQuerying: false, // 手动「重新查询」在途：只有它会锁弹窗，自动轮询不锁
            listQuerying: false, // 列表行「查询收款结果」进行中
            payPendingTimer: null, // pending 自动轮询定时器（1 秒 tick，同时驱动倒计时）
            payPendingRemain: 0, // pending 窗口剩余秒数
            payPendingExpired: false, // pending 窗口是否已到点（转「待人工核查」）
            payErrorMsg: "", // 支付失败错误信息（后端返回）
            removeScanListener: null, // 用于存储移除扫码监听器的函数
            receiptLoading: false,
            receiptChecking: false,
            receiptPreviewVisible: false,
            receiptPrintTime: '',
            paymentReceipt: {
                institutionName: null,
                patientName: null,
                patientAge: null,
                patientGender: null,
                prescriptionType: null,
                doseCount: null,
                receivedAmount: null,
                orderNo: null,
                paidAt: null,
                paymentMethod: null,
                promotion: null
            },
            receiptPromotionImageError: {
                officialAccount: false
            },
            receiptPrintInfoObj: {
                id: 'paymentReceiptPrintArea',
                popTitle: '门诊收款凭证',
                previewTitle: '门诊收款凭证预览',
                extraHead: '<style>@page{size:80mm auto;margin:4mm}.payment-receipt-print{box-sizing:border-box;width:72mm;padding:3mm 2.5mm;color:#111;font-family:"Microsoft YaHei",SimSun,sans-serif;font-size:10pt;line-height:1.5}.receipt-title,.receipt-name,.receipt-subtitle,.receipt-footer,.receipt-barcode-section,.receipt-promotion-title{text-align:center}.receipt-title{font-size:13pt;font-weight:bold;line-height:1.4}.receipt-name{margin-top:1mm;font-size:15pt;font-weight:bold}.receipt-subtitle{margin:.5mm 0 2mm;padding-bottom:2mm;border-bottom:1px solid #111;color:#666;font-size:8pt;letter-spacing:.7px}.receipt-section{padding:1.8mm 0;border-bottom:1px dashed #777}.receipt-section-title{margin-bottom:1mm;font-size:9pt;font-weight:bold}.receipt-payment-title{margin-top:1.8mm}.receipt-row{display:flex;justify-content:space-between;gap:4mm;min-height:5mm}.receipt-row span:last-child{text-align:right;word-break:break-all;font-weight:500}.receipt-amount{display:flex;justify-content:space-between;align-items:center;margin:1.5mm 0;padding:2mm;background:#f3f4f6;font-weight:bold}.receipt-amount strong{font-size:13pt}.receipt-barcode-section{padding:2mm 0;border-bottom:1px dashed #777;font-size:9pt;font-weight:bold}.receipt-barcode-section svg{display:block;width:60mm;height:17mm;margin:1.5mm auto}.receipt-order-no{font-size:9pt;letter-spacing:1px}.receipt-hint,.receipt-footer small,.receipt-promotion-list small{color:#555;font-size:8pt;font-weight:normal}.receipt-promotion-section{padding:2mm 0;border-bottom:1px dashed #777;text-align:center}.receipt-promotion-title{font-size:9pt;font-weight:bold}.receipt-promotion-list{display:flex;justify-content:center;margin-top:1.5mm}.receipt-promotion-list>div{width:58mm;font-size:9pt;font-weight:bold;white-space:nowrap}.receipt-promotion-list img{display:block;width:32mm;height:32mm;margin:0 auto 1mm;object-fit:contain}.receipt-print-time{border-bottom:1px solid #111}.receipt-footer{padding-top:2mm;font-size:9pt}</style>',
                preview: false,
                beforeOpenCallback() {},
                openCallback() {},
                closeCallback() {},
                url: '',
                standard: 'html5',
                extraCss: ''
            },
            decoctionNameMap: {}
        }
    },

    created() {
        getDicts(this.dictOrderStatus).then(res => {
            this.dictOrderStatusList = res.data.data;
        });

        refreshDecoctionNameMap().then(map => {
            this.decoctionNameMap = map;
        }).finally(() => this.getMedicalOrderDetailInfo());

        console.log("this.orderId");
        console.log(this.orderId);
        this.getMedicalOrderDetailInfo();
    },
    mounted() {
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.initScanListener();
    },
    // 在 beforeUnmount 钩子中清理事件监听器（Vue 3 中 beforeDestroy 不会触发）
    beforeUnmount() {
        // 如果存在移除监听器的函数，则调用它
        this.invalidatePaySession();
        if (this.removeScanListener) {
            this.removeScanListener();
        }
    },
    watch: {
        orderPayDialogVisible: {
            flush: 'sync',
            handler() { this.invalidatePaySession(); }
        },
        'medicalOrder.orderId': {
            flush: 'sync',
            handler() { this.resetPaySelection(); }
        },
        orderId: {
            flush: 'sync',
            handler() {
                this.resetPaySelection();
                this.miniIdentityRequestId++;
            }
        },
    },
    computed: {
        // 结果面板主文案：必须与后端三态/渠道一致，pending 不得渲染成失败
        payResultText() {
            if (this.payState === 'success') {
                if (this.payChannel === 'CASH') {
                    return '已现金收款';
                }
                if (this.payChannel === 'FREE') {
                    return '为免费单，无需支付';
                }
                return '已支付成功';
            }
            if (this.payState === 'pending') {
                if (this.payNeedsReview) return '已收款，本地入账待核查，禁止重扫';
                // 窗口到点后转「待人工核查」：仍是「未确认」，绝不能说成失败
                return this.payPendingExpired ? '待人工核查' : '支付结果确认中';
            }
            return '支付失败';
        },
        paymentMethodHint() {
            if (this.paymentMethod === 'SELF_SCAN') return '请患者使用微信扫描门诊收款码付款，核实款项已到账后点击“确定缴费”，系统将登记已支付并打印凭证。';
            if (this.paymentMethod === 'CASH') return '请当面点清患者支付的现金并完成找零，确认实收金额无误后点击“确定缴费”，系统将登记已支付并打印凭证。';
            return '点击“确定缴费”后，请患者打开微信或支付宝付款码供收钱吧盒子扫描，系统确认支付成功后自动打印凭证。';
        },
        payChannelText() {
            const channelLabels = {SQB: '线上支付（收钱吧）', SELF_SCAN: '客户自主扫码', CASH: '现金缴费', FREE: '免费单'};
            return channelLabels[this.payChannel] || '暂未记录';
        },
        canPrintSqbReceipt() {
            return this.isPayed && this.payState === 'success' && ['SQB', 'CASH', 'SELF_SCAN'].includes(this.payChannel);
        },
        // 只锁「请求在途」：支付请求受 axios 70s 超时封顶、手动重查是单次查单耗时，故不可关闭时长上限≈70s。
        // pending 期间放行关闭（结果未定时关窗确实会诱导重扫，但收银员不能被关在只能干等的弹窗里）——
        // 关窗后仍有列表「查询收款结果」、服务端补查阶梯与日终对账三层兜底。
        // 用 manualQuerying 而不是 querying：后者被 10s 自动轮询共用，直接锁会让弹窗每 10 秒闪一下。
        payDialogLocked() {
            return this.payRequesting || this.manualQuerying || this.receiptLoading || this.receiptChecking;
        },
    },
    methods: {
        // epoch + 订单 + 可见性同时匹配，关闭动画期间的旧响应也不能写回。
        capturePaySession() {
            return {epoch: this.paySessionEpoch, orderId: this.medicalOrder.orderId, visible: this.orderPayDialogVisible, detailOrderId: this.orderId};
        },

        isCurrentPaySession(session) {
            return !!session && session.epoch === this.paySessionEpoch
                && session.orderId === this.medicalOrder.orderId && session.detailOrderId === this.orderId
                && session.visible === this.orderPayDialogVisible;
        },

        invalidatePaySession() {
            this.paySessionEpoch++;
            this.stopPayPendingWatch();
            this.payRequesting = false;
            this.querying = false;
            this.manualQuerying = false;
            this.listQuerying = false;
            this.receiptLoading = false;
            this.detailLoading = false;
            if (this.payReviewOrderId !== this.medicalOrder.orderId) {
                this.payNeedsReview = false;
                this.payReasonCode = '';
                this.payReviewOrderId = null;
            }
        },

        resetPaySelection() {
            this.invalidatePaySession();
            this.isWaitPayLoading = false;
            this.paymentMethod = 'SQB';
            this.manualPaymentUncertain = false;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = '';
            this.payChannel = '';
            this.payErrorMsg = '';
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
        },

        resumePayReview() {
            const pending = this.payPendingOrders[this.medicalOrder.orderId];
            if (!pending) return;
            this.payNeedsReview = pending.needsReview;
            this.payReviewOrderId = pending.needsReview ? this.medicalOrder.orderId : null;
            this.payReasonCode = pending.reasonCode;
            this.isWaitPayLoading = false;
            this.isPayed = true;
            this.payState = 'pending';
            // 关窗已中断自动窗口，重开只读补查，不重新起算150秒、更不能恢复扫码。
            this.payPendingExpired = true;
            this.payPendingReopened = true;
            this.payErrorMsg = this.pendingExpiredMessage();
            this.requeryPayResult(true);
        },

        isPayNetworkError(error) {
            return !!error && !error.response && (error.request
                || ['ECONNABORTED', 'ETIMEDOUT', 'ERR_NETWORK'].includes(error.code)
                || error.message === 'Network Error');
        },

        // 扫码枪扫描处理方法
        handleScanCode(code) {
            if (this.orderPayDialogVisible && this.isWaitPayLoading && (!this.isMiniProgramOrder || this.miniIdentitySaved)) {
                // 如果正在等待支付扫码，则处理支付码
                this.processPaymentCode(code);
            } else {
                // 其他情况可根据需要扩展
                console.log('扫描到条码:', code);
            }
        },

        // 处理支付码
        processPaymentCode(dynamicId) {
            if (!dynamicId) {
                message("扫描的条码无效", "error");
                return;
            }
            if (!this.orderPayDialogVisible || !this.isWaitPayLoading || this.paymentMethod !== 'SQB' || !this.medicalOrder.orderId || this.payRequesting || this.querying
                || this.payState === 'pending' || this.payState === 'success' || this.payNeedsReview
                || this.payPendingOrders[this.medicalOrder.orderId] || (this.orderId && String(this.orderId) !== String(this.medicalOrder.orderId))) {
                return;
            }
            this.invalidatePaySession();
            const session = this.capturePaySession();
            // 发出POST即视为结果未决；切单/关窗丢弃回包后，原单也只能只读补查。
            this.payPendingOrders[session.orderId] = {needsReview: false, reasonCode: ''};
            this.payRequesting = true;
            this.payPendingExpired = false;
            this.payPendingRemain = 0;
            this.payPendingReopened = false;
            this.isWaitPayLoading = false;
            this.payLoading = true;
            this.isPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            const params = {
                orderId: session.orderId,
                price: this.medicalOrder.orderPrice,
                dynamicId: dynamicId
            };
            return clinicSqbOrderPay(JSON.stringify(params)).then(response => {
                if (!this.isCurrentPaySession(session)) return;
                return this.applyPayResult(response, false, session);
            }).catch(error => {
                if (!this.isCurrentPaySession(session)) return;
                console.error('支付请求失败:', error);
                // 超时/断网不代表未扣款；HTTP/业务500仍按明确失败处理，不能一概变pending。
                const result = this.isPayNetworkError(error)
                    ? {code: 601, data: {payState: 'pending'}}
                    : ((error && error.response && error.response.data) || {code: 500, msg: '支付请求失败'});
                return this.applyPayResult(result, false, session);
            }).finally(() => {
                if (this.isCurrentPaySession(session)) this.payRequesting = false;
            });
        },

        /**
         * 按后端三态契约渲染收款结果：
         *   code=200 + data.payState=success + data.channel  → 已收款（渠道见 payChannel）
         *   code=601 + data.payState=pending                 → 结果确认中，既非成功也非失败
         *   其余                                             → 明确失败
         *
         * 不能只看 code 是否为 200 就判成功，也不能把 601 当失败 —— 后者会诱导收银员重扫。
         */
        async applyPayResult(response, silent, session = this.capturePaySession()) {
            if (!this.isCurrentPaySession(session) || this.payState === 'success') return;
            this.isWaitPayLoading = false;
            this.payLoading = false;
            this.isPayed = true;
            this.payErrorMsg = "";
            // POST resolve 的是 response.data（带 code/msg/data），GET 查单 resolve 的是完整 axios response，先归一化
            const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
            const data = (payload && payload.data) || {};
            const payState = data.payState;
            const channel = data.channel || "";

            if (payload && payload.code === 200 && payState === 'success') {
                this.payState = 'success';
                delete this.payPendingOrders[session.orderId];
                this.payRequesting = false;
                this.querying = false;
                this.manualQuerying = false;
                this.payNeedsReview = false;
                this.payReviewOrderId = null;
                this.payReasonCode = '';
                this.payChannel = channel;
                this.successPayed = true;
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                message(this.paySuccessText(channel), "success");
                this.$emit('order-updated');
                // 实际收款渠道均打印服务端签发的门诊凭证，免费单除外。
                if (!['SQB', 'CASH', 'SELF_SCAN'].includes(channel)) {
                    this.resetReceipt();
                    return;
                }
                try {
                    if (!this.isCurrentPaySession(session)) return;
                    await this.getMedicalOrderDetailInfo(session);
                    if (!this.isCurrentPaySession(session)) return;
                    await this.$nextTick();
                    if (!this.isCurrentPaySession(session)) return;
                    await this.openPaymentReceipt(false, session);
                } catch (error) {
                    if (!this.isCurrentPaySession(session)) return;
                    console.error('支付成功后的订单详情刷新失败:', error);
                    message("支付成功，但订单详情刷新失败，请手动打印凭证", "warning");
                }
            } else if ((payload && payload.code === 601 && payState === 'pending') || this.payNeedsReview) {
                if (data.externalPayState === 'PAID' && data.localPostingState === 'needsReview') {
                    this.payNeedsReview = true;
                    this.payReviewOrderId = session.orderId;
                    this.payReasonCode = data.reasonCode || this.payReasonCode;
                }
                // AC3：第三态。既不得显示成功，也不得显示失败。
                this.payState = 'pending';
                this.payPendingOrders[session.orderId] = {needsReview: this.payNeedsReview, reasonCode: this.payReasonCode};
                this.payChannel = "";
                this.successPayed = false;
                if (!this.payPendingTimer && !this.payPendingExpired) {
                    // 首次进入 pending：开自动轮询窗口（与后端支付锁 TTL 对齐）
                    this.startPayPendingWatch();
                }
                this.payErrorMsg = this.payPendingExpired
                    ? this.pendingExpiredMessage()
                    : this.pendingMessage();
                if (!silent) {
                    message(this.payNeedsReview ? this.payErrorMsg : "支付结果确认中，请勿重复扫码", "warning");
                }
            } else {
                this.payState = 'failed';
                delete this.payPendingOrders[session.orderId];
                this.stopPayPendingWatch();
                this.payPendingExpired = false;
                this.payChannel = "";
                this.successPayed = false;
                this.payErrorMsg = (payload && payload.msg) || "支付失败";
                message(this.payErrorMsg, "error");
            }
        },

        // 收款渠道对应的成功文案（AC5 / AC6：免费单、现金收款不得说成「收钱吧支付成功」）
        paySuccessText(channel) {
            if (channel === 'SELF_SCAN') return '该订单已确认客户自主扫码收款';
            if (channel === 'CASH') {
                return "该订单已现金收款";
            }
            if (channel === 'FREE') {
                return "该订单为免费单，无需支付";
            }
            return "支付成功";
        },

        // AC3：pending 态的「重新查询」。走只读查单接口，绝不会发起扣款，可安全重复点击。
        requeryPayResult(silent) {
            const session = this.capturePaySession();
            if (!this.orderPayDialogVisible || this.querying || !session.orderId || this.payState === 'success') {
                return;
            }
            this.querying = true;
            if (!silent) {
                // 只有手动重查锁弹窗；自动轮询不锁，否则 pending 期间弹窗每 10 秒闪一下
                this.manualQuerying = true;
            }
            //silent=true 就是自动轮询（弹窗每 10 秒一次）：把它作为 autoPoll 传给后端，
            //让「机器在等」与「收银员点了一次」在查单留痕里可区分
            return clinicSqbQueryResult(session.orderId, !!silent).then(response => {
                if (!this.isCurrentPaySession(session)) return;
                return this.applyPayResult(response, silent, session);
            }).catch(error => {
                if (!this.isCurrentPaySession(session) || this.payState === 'success') return;
                console.error('重新查询支付结果失败:', error);
                if (!silent) {
                    message("重新查询失败，请稍后重试", "error");
                }
            }).finally(() => {
                if (!this.isCurrentPaySession(session)) return;
                this.querying = false;
                this.manualQuerying = false;
            });
        },

        // 列表行「查询收款结果」：弹窗关闭后仍可从这里补查。只读查单，绝不发起扣款。
        // autoPoll 传 false：后端据此把留痕记成 manual（只有弹窗自动轮询才传 true）。
        queryListPayResult(row) {
            if (this.listQuerying || !row.orderId) {
                return;
            }
            const session = this.capturePaySession();
            const orderId = row.orderId;
            this.listQuerying = true;
            return clinicSqbQueryResult(orderId, false).then(response => {
                if (!this.isCurrentPaySession(session) || orderId !== row.orderId) return;
                const payload = (response && response.data && response.data.code !== undefined) ? response.data : response;
                const data = (payload && payload.data) || {};
                if (payload && payload.code === 200 && data.payState === 'success') {
                    delete this.payPendingOrders[orderId];
                    message("该订单已通过收钱吧支付", "success");
                    this.getOrderList();
                } else if (payload && payload.code === 601 && data.payState === 'pending') {
                    const previous = this.payPendingOrders[orderId] || {};
                    this.payPendingOrders[orderId] = {
                        needsReview: previous.needsReview || (data.externalPayState === 'PAID' && data.localPostingState === 'needsReview'),
                        reasonCode: data.reasonCode || previous.reasonCode || ''
                    };
                    //601 是正常业务态，绝不能报 error —— 报错会诱导收银员重扫
                    message(data.externalPayState === 'PAID' && data.localPostingState === 'needsReview'
                        ? "已收款，本地入账待核查，禁止重扫，请人工核账" : "收款结果仍未确认，请稍后再查", "warning");
                } else {
                    //含「该订单尚未发起过扫码支付，无法查询支付结果」，原样透出后端文案
                    message((payload && payload.msg) || "查询收款结果失败", "error");
                }
            }).catch(error => {
                if (!this.isCurrentPaySession(session) || orderId !== row.orderId) return;
                console.error('查询收款结果失败:', error);
                message("查询收款结果失败，请稍后重试", "error");
            }).finally(() => {
                if (this.isCurrentPaySession(session)) this.listQuerying = false;
            });
        },

        /**
         * 开始 pending 自动轮询：每 PAY_PENDING_POLL_INTERVAL_SECONDS 秒查一次只读查单接口，
         * 最长 PAY_PENDING_WINDOW_SECONDS 秒；到点转「待人工核查」。
         *
         * 窗口到点仅停止自动查询，仍可手动只读查单；结果未定/已收款待核查均禁止重扫。
         */
        startPayPendingWatch() {
            this.stopPayPendingWatch();
            this.payPendingExpired = false;
            this.payPendingRemain = PAY_PENDING_WINDOW_SECONDS;
            const session = this.capturePaySession();
            const timer = setInterval(() => {
                if (!this.isCurrentPaySession(session)) {
                    clearInterval(timer);
                    return;
                }
                // 状态已被其他路径改写（成功/失败/重置）时窗口自行结束，
                // 这样各处的重置逻辑不必逐个记得清定时器
                if (this.payState !== 'pending') {
                    this.stopPayPendingWatch();
                    return;
                }
                this.payPendingRemain -= 1;
                if (this.payPendingRemain <= 0) {
                    this.stopPayPendingWatch();
                    this.markPayPendingExpired();
                    return;
                }
                this.payErrorMsg = this.pendingMessage();
                if (this.payPendingRemain % PAY_PENDING_POLL_INTERVAL_SECONDS === 0) {
                    // 自动轮询不弹 toast，避免每 10 秒打扰收银员一次
                    this.requeryPayResult(true);
                }
            }, 1000);
            this.payPendingTimer = timer;
        },

        stopPayPendingWatch() {
            if (this.payPendingTimer) {
                clearInterval(this.payPendingTimer);
                this.payPendingTimer = null;
            }
        },

        // 窗口到点：转「待人工核查」。绝不能说成「支付失败」—— 钱可能已经收了。
        markPayPendingExpired() {
            this.payPendingExpired = true;
            this.payErrorMsg = this.pendingExpiredMessage();
            message(this.payErrorMsg, "warning");
        },

        pendingMessage() {
            if (this.payNeedsReview) return '已收款，本地入账待核查，禁止重扫（只读查询中）' + (this.payReasonCode ? '，原因：' + this.payReasonCode : '');
            return "支付结果确认中，请勿重复扫码（自动查询中，剩余 " + this.payPendingRemain + " 秒）";
        },

        pendingExpiredMessage() {
            if (this.payNeedsReview) return '已收款，本地入账待核查，禁止重扫，请人工核账' + (this.payReasonCode ? '，原因：' + this.payReasonCode : '');
            if (this.payPendingReopened) return "支付结果仍未确认，请只读查询收款结果，禁止重复扫码";
            return "支付结果超过 " + PAY_PENDING_WINDOW_SECONDS + " 秒仍未确认，请人工核查收钱吧流水";
        },

        // 替换原有的 initScanListener 方法
        initScanListener() {
            let barcode = '';
            let barcodeTimeout;

            // 只在支付等待界面启用扫码枪监听
            const handleKeyDown = (e) => {
                // 只在订单支付弹窗显示且正在等待扫码时处理
                if (!this.orderPayDialogVisible || !this.isWaitPayLoading) {
                    return;
                }

                // 检查目标元素是否为输入框，如果是则不处理（避免干扰正常输入）
                const target = e.target;
                if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
                    return;
                }

                console.log("e.key >>>> " + e.key);
                // 排除功能键
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt') {
                    return;
                }

                // 清除之前的超时
                clearTimeout(barcodeTimeout);

                // 如果按下了回车键，表示扫码结束
                if (e.key === 'Enter') {
                    if (barcode.length > 0) {
                        if (barcode.indexOf("CapsLock") > -1) {
                            barcode = barcode.replace("CapsLock", "");
                        }
                        console.log('扫码完成barcode:', barcode);
                        this.handleScanCode(barcode);
                        barcode = ''; // 重置
                    }
                } else {
                    // 累加字符
                    barcode += e.key;
                }

                // 设置超时，如果在100ms内没有新的输入，则认为扫码完成
                barcodeTimeout = setTimeout(() => {
                    if (barcode.length > 0) {
                        console.log('扫码超时完成:', barcode);
                        barcode = ''; // 重置
                    }
                }, 100);
            };

            // 添加事件监听器
            document.addEventListener('keydown', handleKeyDown);

            // 保存移除监听器的函数，以便在组件销毁时调用
            this.removeScanListener = () => {
                document.removeEventListener('keydown', handleKeyDown);
            };
        },


        getOrderStatus(dictCode) {
            return this.getDictValue(dictCode, this.dictOrderStatusList);
        },

        getDictValue(dictKey, dictList) {
            let str = '';
            dictList.forEach(e => {
                if (e.dictValue == dictKey) {
                    str = e.dictLabel;
                }
            })
            return str;
        },

        // 获取订单详情信新
        getMedicalOrderDetailInfo(session) {
            const orderId = this.orderId;
            if (session && !this.isCurrentPaySession(session)) return Promise.resolve();
            const requestId = ++this.detailRequestId;
            const epoch = this.paySessionEpoch;
            console.log(this.orderId);
            this.detailLoading = true;
            return getMedicalOrderDetail(orderId).then(response => {
                if (requestId !== this.detailRequestId || epoch !== this.paySessionEpoch
                    || orderId !== this.orderId || (session && !this.isCurrentPaySession(session))) return;
                console.log(response);
                if (response.data.code === 200) {
                    this.detailLoading = false;
                    this.patientInfo = response.data.data.patientInfo;
                    if (this.patientInfo.sex === "1") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                    } else if (this.patientInfo.sex === "0") {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                    } else {
                        this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                    }
                    this.doctorInfo = response.data.data.doctorInfo;
                    console.log("response.data.data.docPriceHide");
                    console.log(this.doctorInfo);
                    if (this.doctorInfo.docPrice === null || this.doctorInfo.docPrice === undefined || this.doctorInfo.docPrice === '') {
                        this.doctorInfo.docPrice = "0";
                    }
                    if (this.doctorInfo.docPriceRate === null || this.doctorInfo.docPriceRate === undefined || this.doctorInfo.docPriceRate === '') {
                        this.doctorInfo.docPriceRate = "0";
                    }
                    if (this.doctorInfo.docPriceHide === null || this.doctorInfo.docPriceHide === undefined || this.doctorInfo.docPriceHide === '') {
                        this.doctorInfo.docPriceHide = "0";
                    }
                    console.log(this.doctorInfo.docPriceHide);
                    this.medicalOrder = response.data.data.medicalOrder;
                    this.isMiniProgramOrder = ['patient', 'patientRepeat', 'doc', 'docRepeat'].includes(this.medicalOrder.orderSource);
                    if (this.medicalOrder.docAdvice === null) {
                        this.medicalOrder.docAdvice = '每日一副 分两次服用（开水冲化 温服）';
                    }
                    if (this.medicalOrder.picUrl !== null && this.medicalOrder.picUrl !== "") {
                        this.medicalOrder.picUrl = this.tencentCosUrl + this.medicalOrder.picUrl;
                    }
                    this.payCodeList = [];
                    this.payCodeList.push(this.tencentCosUrl+this.medicalOrder.payQrcode);
                    if (this.medicalOrder.takeWay === "null" || this.medicalOrder.takeWay === null) {
                        this.medicalOrder.takeWay = "0";
                    }
                    if (this.medicalOrder.viceNum === null || this.medicalOrder.viceNum === undefined || this
                        .medicalOrder.viceNum === "") {
                        this.medicalOrder.viceNum = "1";
                    }
                    this.indexMedicine = this.medicalOrder.billingType === null ? '0' : this.medicalOrder.billingType;
                    this.indexeat = parseInt(this.medicalOrder.takeWay === null ? '0' : this.medicalOrder.takeWay);
                    this.indexSex = parseInt(this.medicalOrder.patientSex === null ? '0' : this.medicalOrder.patientSex);

                    this.medicalOrder.packWay = this.medicalOrder.packWay === null ? '0' : this.medicalOrder.packWay;

                    this.medicalOrder.dayTakeNum = this.medicalOrder.dayTakeNum === null ? '1' : this.medicalOrder.dayTakeNum;//X日一剂
                    this.medicalOrder.takeTimes = this.medicalOrder.takeTimes === null ? '2' : this.medicalOrder.takeTimes;// 每日分X次服用/每日X次
                    this.medicalOrder.timeUseNum = this.medicalOrder.timeUseNum === null ? '1' : this.medicalOrder.timeUseNum;// 每次XX克、XX毫升

                    this.docMedicineArray = [];
                    var orderMedicineList = this.medicalOrder.orderMedicineList;
                    console.log("orderMedicineList");
                    console.log(orderMedicineList);
                    if (orderMedicineList !== null) {
                        orderMedicineList.forEach(melist => {
                            let decoctWay = melist.decoctWay;
                            let decoctionName = getDecoctionName(decoctWay, this.decoctionNameMap);
                            melist.meName = melist.meName.replaceAll("配方", "").replaceAll("颗粒", "").replaceAll("饮片", "");
                            this.docMedicineArray.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                price: melist.medicinePrice,
                                gCount: melist.countNum,
                                newGCount: melist.newGCount,
                                meRemark: melist.meDesc,
                                mCount: melist.totalPrice,
                                decoctionId: decoctWay,
                                decoctionName: decoctionName,
                                drugProperty: melist.drugProperty
                            });
                        })
                    }

                    this.chooseFuliaoList = [];
                    var orderMedicineFuList = this.medicalOrder.orderMedicineFuList;
                    console.log("orderMedicineFuList");
                    console.log(orderMedicineFuList);
                    if (orderMedicineFuList !== null) {
                        orderMedicineFuList.forEach(melist => {
                            this.chooseFuliaoList.push({
                                medicineId: melist.medicineId,
                                meName: melist.meName,
                                meDesc: melist.meDesc,
                                price: melist.price,
                                meCount: melist.countNum,
                                countPrice: melist.totalPrice
                            });
                        })
                    }

                    if (this.docMedicineArray.length > 0) {
                        this.docMedicineArray.forEach(docMedlist => {
                            docMedlist.decoctWay = docMedlist.decoctionId;
                        });
                        this.medicalOrder.orderMedicineList = this.docMedicineArray;
                    }
                    // 列表直达收费：以最新服务端状态为准，单个组件实例仅自动打开一次。
                    if ((this.paymentOnly || this.printOnly) && !this.paymentOnlyOpened) {
                        this.paymentOnlyOpened = true;
                        if (this.printOnly) {
                            // 等待凭证模板与打印指令挂载，沿用原有付款核对和打印流程。
                            this.$nextTick(() => this.printPaymentReceipt());
                        } else if (this.medicalOrder.status === '3') {
                            this.openPayScreen();
                        } else {
                            message('订单已不是待支付状态，请刷新列表核对。', 'warning');
                            this.$emit('order-updated');
                        }
                    }
                    // this.reCount();
                } else {
                    this.detailLoading = false;
                    message(response.data.msg, 'error');
                    throw new Error(response.data.msg || '订单详情获取失败');
                }
            });

        },


        // 订单收费
        openPayScreen() {
            this.invalidatePaySession();
            this.orderPayDialogVisible = true;
            // 小程序历史非空值也可能是“1”；每次收费均核对，服务端负责校验与差异确认。
            this.needsIdentityBinding = ['patient', 'patientRepeat', 'doc', 'docRepeat'].includes(this.medicalOrder.orderSource);
            this.isWaitPayLoading = false;
            this.paymentMethod = 'SQB';
            this.manualPaymentUncertain = false;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            this.isMiniProgramOrder = ['patient', 'patientRepeat', 'doc', 'docRepeat'].includes(this.medicalOrder.orderSource);
            this.miniIdentityReview = null;
            this.miniIdentityOptions = [];
            this.selectedMiniIdentity = '';
            this.manualMiniIdentity = '';
            this.miniIdentityQueryCompleted = false;
            this.miniIdentityError = '';
            this.miniIdentityRequestId++;
            this.miniIdentityLoading = false;
            this.miniIdentitySaved = !this.needsIdentityBinding;
            if (this.needsIdentityBinding) this.loadMiniOrderIdentityOptions();
            this.resetReceipt();
            this.resumePayReview();
        },

        async loadMiniOrderIdentityOptions() {
            if (this.miniIdentitySaving || this.miniIdentityLoading) return;
            this.miniIdentityLoading = true;
            this.miniIdentityQueryCompleted = false;
            this.miniIdentitySaved = false;
            const requestId = ++this.miniIdentityRequestId;
            this.miniIdentityError = '';
            try {
                const response = await getMiniOrderIdentityReservations(this.medicalOrder.orderId);
                if (requestId !== this.miniIdentityRequestId || !this.orderPayDialogVisible) return;
                if (!response.data || response.data.code !== 200 || !Array.isArray(response.data.data)) {
                    throw new Error((response.data && response.data.msg) || '预约信息查询失败');
                }
                this.miniIdentityReview = response.data.identityReview || null;
                this.miniIdentityQueryCompleted = true;
                const seen = new Set();
                this.miniIdentityOptions = response.data.data.filter(row => {
                    if (!row.cardIdentity || seen.has(row.cardIdentity)) return false;
                    seen.add(row.cardIdentity);
                    return true;
                });
                // 有效订单身份证优先，其次是患者档案；只有没有可用原信息时才默认选择唯一预约候选。
                // 这里必须使用与下拉选项匹配的业务值，避免把内部值 order/profile 直接展示给前台。
                const review = this.miniIdentityReview;
                if (review && review.identityConsistentAndValid) {
                    this.selectedMiniIdentity = 'current';
                } else if (review && review.orderIdentityValid) {
                    this.selectedMiniIdentity = 'order';
                } else if (review && review.profileIdentityValid) {
                    this.selectedMiniIdentity = 'profile';
                } else {
                    this.selectedMiniIdentity = this.miniIdentityOptions.length === 1
                        ? this.miniIdentityOptions[0].reId : this.miniIdentityOptions.length ? '' : 'manual';
                }
                this.manualMiniIdentity = '';
                this.miniIdentitySaved = false;
            } catch (error) {
                if (requestId !== this.miniIdentityRequestId || !this.orderPayDialogVisible) return;
                // 业务拒绝必须保留后端原因，不能误导前台反复重试预约查询。
                const detail = error.response && error.response.data;
                this.miniIdentityError = (detail && detail.msg) || error.message || '身份信息查询失败，请检查网络后重试';
                this.miniIdentityReview = null;
                this.miniIdentityOptions = [];
                this.selectedMiniIdentity = '';
                this.miniIdentitySaved = false;
            } finally {
                if (requestId === this.miniIdentityRequestId) this.miniIdentityLoading = false;
            }
        },

        miniIdentityProposed() {
            const selected = this.miniIdentityOptions.find(row => row.reId === this.selectedMiniIdentity);
            if (this.selectedMiniIdentity === 'current' || this.selectedMiniIdentity === 'order') return this.miniIdentityReview.orderIdentity;
            if (this.selectedMiniIdentity === 'manual') return String(this.manualMiniIdentity || '').trim().toUpperCase();
            if (!selected && !['current', 'order', 'profile'].includes(this.selectedMiniIdentity)) return '';
            if (this.selectedMiniIdentity === 'profile') return this.miniIdentityReview.profileIdentity;
            return selected ? String(selected.cardIdentity).trim().toUpperCase() : '';
        },

        miniIdentitySourceLabel() {
            if (this.selectedMiniIdentity === 'order' || this.selectedMiniIdentity === 'current') return '订单原信息';
            if (this.selectedMiniIdentity === 'profile') return '患者档案';
            return this.miniIdentityOptions.some(row => row.reId === this.selectedMiniIdentity) ? '预约信息（待对照证件）' : '待选择';
        },

        miniIdentityReviewText() {
            const review = this.miniIdentityReview;
            if (!review) return '';
            const proposed = this.miniIdentityProposed();
            const describe = (value, valid) => !value ? '未填写' : `${value}（${valid ? '格式有效' : '格式无效'}）`;
            const different = proposed && (review.orderIdentity !== proposed || review.profileIdentity !== proposed);
            return `订单原身份证：${describe(review.orderIdentity, review.orderIdentityValid)}；患者档案身份证：${describe(review.profileIdentity, review.profileIdentityValid)}。`
                + (proposed ? `本次选择：${proposed}。` : '请选择正确的身份证。')
                + (different ? '与原身份证存在差异，保存后仅更新当前订单身份证。' : '保存后仅更新当前订单身份证。')
                + '请对照患者证件核实身份证，确认后点击“保存确定”。';
        },

        async confirmMiniPatientIdentity() {
            if (this.miniIdentitySaved || this.miniIdentitySaving || this.miniIdentityLoading) return;
            if (!this.miniIdentityQueryCompleted || this.miniIdentityError) {
                message('请先完成预约信息查询', 'warning');
                return;
            }
            const identity = this.miniIdentityProposed();
            // 订单、档案及当前核验项都是身份证来源标记，不是预约 ID，统一按号码提交。
            const manual = ['manual', 'current', 'order', 'profile'].includes(this.selectedMiniIdentity);
            if (!/^\d{17}[\dX]$/.test(identity)) {
                message('请输入18位有效身份证号码', 'warning');
                return;
            }
            if (!manual && !this.selectedMiniIdentity) {
                message('请选择预约人身份证信息', 'warning');
                return;
            }
            if (!this.miniIdentityReview || !this.miniIdentityReview.confirmationBase) {
                message('身份证核对信息已失效，请重新查询', 'warning');
                return;
            }
            const payload = {orderId: this.medicalOrder.orderId};
            if (manual) payload.patientIdentity = identity;
            else payload.reservationId = this.selectedMiniIdentity;
            const selected = this.miniIdentityOptions.find(row => row.reId === this.selectedMiniIdentity);
            const proposedIdentity = manual ? identity
                : String(selected ? selected.cardIdentity : identity).trim().toUpperCase();
            payload.confirmationToken = this.miniIdentityReview.confirmationBase + proposedIdentity;
            this.miniIdentitySaving = true;
            const requestId = this.miniIdentityRequestId;
            try {
                const response = await bindMiniPatientIdentity(payload);
                if (requestId !== this.miniIdentityRequestId || !this.orderPayDialogVisible) return;
                // 数据变化时更新窗口中的核验结果，不自动重试或弹出第二次确认。
                if (response && response.code === 200 && response.data && response.data.confirmationRequired) {
                    this.miniIdentityReview = response.data;
                    // 后端返回最新订单/档案快照，需重新确认身份证后再保存。
                    message('患者信息已变化，已更新差异说明，请重新核对后保存', 'warning');
                    this.miniIdentitySaved = false;
                    return;
                }
                if (response && response.code === 200) {
                    const responseIdentity = response.data && response.data.patientIdentity;
                    const savedIdentity = responseIdentity || (manual ? identity : selected.cardIdentity);
                    // 保存成功后只刷新订单身份证，不改患者档案；手机号仅由后端同步到订单。
                    this.medicalOrder.patientIdentity = savedIdentity;
                    this.miniIdentitySaved = true;
                    message('患者身份证已保存', 'success');
                } else {
                    message((response && response.msg) || '患者身份证关联失败', 'error');
                }
            } catch (error) {
                if (requestId === this.miniIdentityRequestId) message('患者身份证关联失败，请稍后重试', 'error');
            } finally {
                if (requestId === this.miniIdentityRequestId) this.miniIdentitySaving = false;
            }
        },

        async confirmOrderPayment() {
            if (this.payDialogLocked || this.receiptLoading || this.isPayed || this.isWaitPayLoading || this.manualPaymentUncertain
                || this.payPendingOrders[this.medicalOrder.orderId] || this.payNeedsReview) return;
            if (!this.orderPayDialogVisible || !this.medicalOrder.orderId || this.medicalOrder.status !== '3') return;
            if (this.needsIdentityBinding && !this.miniIdentitySaved) {
                message('请先确认并关联患者身份证信息', 'warning');
                return;
            }
            if (this.paymentMethod === 'SQB') {
                this.isWaitPayLoading = true;
                await this.$nextTick();
                if (document.activeElement && typeof document.activeElement.blur === 'function') document.activeElement.blur();
                return;
            }
            if (!['CASH', 'SELF_SCAN'].includes(this.paymentMethod)) return;
            const session = this.capturePaySession();
            const channel = this.paymentMethod;
            this.payRequesting = true;
            this.payLoading = true;
            try {
                const request = channel === 'CASH' ? confirmMedicalOrderCashPayment : confirmMedicalOrderSelfScanPayment;
                const response = await request(session.orderId);
                if (!this.isCurrentPaySession(session)) return;
                const payload = response && response.data && response.data.code !== undefined ? response.data : response;
                if (!payload || payload.code !== 200) {
                    message((payload && payload.msg) || '确认缴费失败，请核对订单状态', 'error');
                    return;
                }
                // 回读真实入账状态，不在客户端硬改订单状态。
                await this.getMedicalOrderDetailInfo(session);
                if (!this.isCurrentPaySession(session)) return;
                if (!this.medicalOrder.payTime || this.medicalOrder.status === '3') throw new Error('订单入账状态尚未确认');
                await this.applyPayResult({code: 200, data: {payState: 'success', channel}}, false, session);
            } catch (error) {
                if (!this.isCurrentPaySession(session)) return;
                this.manualPaymentUncertain = true;
                message('缴费结果尚未确认，请关闭弹窗并刷新订单、核对收款记录；请勿重复收费。', 'warning');
            } finally {
                if (this.isCurrentPaySession(session)) {
                    this.payRequesting = false;
                    this.payLoading = false;
                }
            }
        },


        // 支付失败刷新重试
        cancalOrRefreshPay() {
            if (this.payState !== 'failed' || this.payNeedsReview || this.payDialogLocked) return;
            this.invalidatePaySession();
            this.isWaitPayLoading = false;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            this.getMedicalOrderDetailInfo();
            this.resetReceipt();
        },


        // 打印待支付单据
        printPayInfo() {
            if (this.payDialogLocked) return;
            this.invalidatePaySession();
            this.orderPayDialogVisible = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
        },


        // 取消支付
        cancalPay() {
            if (this.receiptLoading) {
                message('正在准备支付凭证，请稍候', 'warning');
                return;
            }
            // 等待期（请求在途 / 结果确认中）不允许关闭：结果未定时关窗会诱导收银员重扫，
            // 而扣款可能已经发生。此处同时兜住 X、点遮罩、ESC 与「取消」按钮四条关闭路径。
            if (this.payDialogLocked) {
                message("查询支付结果中，请勿关闭弹窗", "warning");
                return;
            }
            if (this.miniIdentitySaving) {
                message('正在关联患者信息，请稍候', 'warning');
                return;
            }
            this.miniIdentityRequestId++;
            this.miniIdentityLoading = false;
            this.invalidatePaySession();
            this.orderPayDialogVisible = false;
            this.isMiniProgramOrder = false;
            this.miniIdentitySaved = false;
            this.isWaitPayLoading = true;
            this.payLoading = false;
            this.isPayed = false;
            this.successPayed = false;
            this.payState = "";
            this.payChannel = "";
            this.payErrorMsg = "";
            this.resetReceipt();
            // 关闭收费弹窗后重新查询待支付列表，避免遗漏同一患者的其他处方。
            this.$emit('order-updated');
        },

        resetReceipt() {
            this.receiptLoading = false;
            this.receiptPreviewVisible = false;
            this.receiptPrintTime = '';
            this.receiptPromotionImageError = {officialAccount: false};
            this.paymentReceipt = {institutionName: null, patientName: null, patientAge: null, patientGender: null, prescriptionType: null, doseCount: null, receivedAmount: null, orderNo: null, paidAt: null, paymentMethod: null, promotion: null};
        },

        displayReceiptValue(value) {
            return value === null || value === undefined || value === '' ? '--' : value;
        },

        receiptInstitutionName(value) {
            return value === null || value === undefined || value === '' ? '知夏中医' : value;
        },

        formatReceiptGender(value) {
            return value === '0' || value === 0 ? '男' : value === '1' || value === 1 ? '女' : '未知';
        },

        formatReceiptPrescriptionType(value) {
            const prescriptionTypes = {
                0: '颗粒',
                1: '饮片',
                2: '膏方',
                3: '水丸'
            };
            return Object.prototype.hasOwnProperty.call(prescriptionTypes, value) ? prescriptionTypes[value] : '--';
        },

        formatReceiptPaymentMethod(value) {
            if (value === null || value === undefined || value === '') return '在线支付';
            const paymentMethod = String(value).trim();
            if (/微信|weixin|wechat/i.test(paymentMethod)) return '微信支付';
            if (/支付宝|alipay/i.test(paymentMethod)) return '支付宝';
            if (/银行卡|bank|card/i.test(paymentMethod)) return '银行卡';
            return paymentMethod;
        },

        formatReceiptAge(value) {
            return value === null || value === undefined || value === '' ? '--' : value + '岁';
        },

        // 收费弹窗统一两位小数，仅格式化展示，不修改订单金额及支付参数。
        formatCashierAmount(value) {
            if (value === null || value === undefined || value === '') return '0.00';
            const amount = Number(value);
            return Number.isFinite(amount) ? amount.toFixed(2) : '--';
        },

        formatReceiptAmount(value) {
            const amount = Number(value);
            return Number.isFinite(amount) ? '￥' + amount.toFixed(2) : '--';
        },


        handleReceiptPromotionImageError(type) {
            this.receiptPromotionImageError[type] = true;
            message("推广二维码加载失败，本次凭条不含该推广信息", "warning");
        },

        hasReceiptPromotion() {
            return !this.receiptPromotionImageError.officialAccount && officialAccountQrCode;
        },

        receiptOfficialAccountQrCode() {
            return officialAccountQrCode;
        },

        waitForReceiptPromotionImages() {
            const printArea = this.$refs.paymentReceiptPrintArea;
            if (!printArea || typeof printArea.querySelectorAll !== 'function') {
                return Promise.resolve();
            }
            const images = printArea.querySelectorAll('.receipt-promotion-list img');
            return Promise.all(Array.from(images).map(image => {
                if (image.complete) return Promise.resolve();
                return new Promise(resolve => {
                    image.addEventListener('load', resolve, {once: true});
                    image.addEventListener('error', resolve, {once: true});
                });
            }));
        },

        previewPaymentReceipt() {
            this.openPaymentReceipt(true);
        },

        refreshAfterReceiptPrint(session) {
            if (!this.isCurrentPaySession(session)) return;
            this.$emit('order-updated');
            this.getMedicalOrderDetailInfo(session).catch(error => {
                console.error('打印后刷新订单详情失败:', error);
            });
        },
        async printPaymentReceipt() {
            if (this.receiptLoading || this.receiptChecking || !this.medicalOrder.orderId) return;
            const session = this.capturePaySession();
            if (this.medicalOrder.payTime && this.medicalOrder.status !== '3' && this.payState !== 'pending') {
                return this.openPaymentReceipt(false, session);
            }
            this.receiptChecking = true;
            try {
                await ElMessageBox.confirm(
                    '系统订单仍显示未支付，客户可能已付款。请先核对实际到账情况，确认无误后再打印支付凭证。确定打印吗？',
                    '打印前请核对付款',
                    {confirmButtonText: '确定打印', cancelButtonText: '取消', type: 'warning', closeOnClickModal: false}
                );
                if (!this.isCurrentPaySession(session)) return;
                this.paymentReceipt = {
                    institutionName: null,
                    patientName: this.patientInfo.name,
                    patientAge: this.patientInfo.age,
                    patientGender: this.patientInfo.sex,
                    prescriptionType: this.medicalOrder.billingType,
                    doseCount: this.medicalOrder.viceNum,
                    receivedAmount: this.medicalOrder.orderPrice,
                    orderNo: this.medicalOrder.serialNo,
                    paidAt: null,
                    paymentMethod: this.paymentMethod === 'CASH' ? '现金支付' : this.paymentMethod === 'SELF_SCAN' ? '客户自主扫码' : '在线支付',
                    promotion: null
                };
                this.receiptPrintTime = this.getDayDateNow();
                this.receiptPromotionImageError = {officialAccount: false};
                await this.$nextTick();
                if (!this.isCurrentPaySession(session)) return;
                await this.waitForReceiptPromotionImages();
                if (!this.isCurrentPaySession(session)) return;
                this.$refs.paymentReceiptPrintButton.$el.click();
                this.refreshAfterReceiptPrint(session);
            } catch (error) {
                if (!this.isCurrentPaySession(session) || error === 'cancel' || error === 'close') return;
                console.error('支付凭证打印失败:', error);
                message('打印失败，请检查打印机后重试', 'error');
            } finally {
                this.receiptChecking = false;
            }
        },

        openPaymentReceipt(preview, session = this.capturePaySession()) {
            if (!this.isCurrentPaySession(session)) return;
            if (this.receiptLoading || !this.medicalOrder.orderId) {
                if (!this.medicalOrder.orderId) message("未获取到订单信息，请重新进入订单详情后重试", "error");
                return;
            }
            this.receiptLoading = true;
            return getMedicalOrderPaymentReceipt(session.orderId).then(async response => {
                if (!this.isCurrentPaySession(session)) return;
                if (response.data.code !== 200 || !response.data.data) throw new Error(response.data.msg || '收款凭证数据获取失败');
                this.paymentReceipt = response.data.data;
                this.receiptPrintTime = this.getDayDateNow();
                this.receiptPromotionImageError = {officialAccount: false};
                await this.$nextTick();
                if (!this.isCurrentPaySession(session)) return;
                if (preview) {
                    this.receiptPreviewVisible = true;
                    return;
                }
                await this.waitForReceiptPromotionImages();
                if (!this.isCurrentPaySession(session)) return;
                this.$refs.paymentReceiptPrintButton.$el.click();
                this.refreshAfterReceiptPrint(session);
            }).catch(error => {
                if (!this.isCurrentPaySession(session)) return;
                console.error('门诊收款凭证打印失败:', error);
                const errorMessage = preview ? "收款凭证预览加载失败，请稍后重试" : "暂未能获取或打印支付凭证，请先核对订单支付结果；确认已支付后可重试打印，勿重复收费";
                ElMessageBox.alert(errorMessage, "凭证处理提示", {
                    confirmButtonText: "知道了",
                    type: "warning"
                }).catch(() => {});
            }).finally(() => {
                if (this.isCurrentPaySession(session)) this.receiptLoading = false;
            });
        },


        // 获取当前时间
        getDayDateNow() {
            let nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = this.checkTime(nowDate.getMonth() + 1);
            let date = this.checkTime(nowDate.getDate());
            let hour = this.checkTime(nowDate.getHours());
            let minute = this.checkTime(nowDate.getMinutes());
            let second = this.checkTime(nowDate.getSeconds());
            return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
        },

        checkTime(a) {
            if (a < 10) {
                a = "0" + a;
            }
            return a;
        },

    }
}
